import { useEffect } from 'react';
import { useAuiState } from '@assistant-ui/react';
import { setActionTurnRunning } from './action-presentation';

// Lives inside the runtime provider; canvas cards live outside it. Only this
// observer translates runtime lifecycle into thread-scoped presentation events.
export function ActionTurnObserver({ threadId }: { threadId: string }) {
  const running = useAuiState((state) => state.thread.isRunning);
  useEffect(() => {
    setActionTurnRunning(threadId, running);
  }, [threadId, running]);
  useEffect(() => () => setActionTurnRunning(threadId, false), [threadId]);
  return null;
}
